<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Заполнение ингредиента: {{ this.ingredient.component.name }}</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Текущий остаток ингредиента</label>
          <input
            type="text"
            class="form-control"
            name="ingredientCurrentRemainder"
            v-validate="'required'"
            v-model="this.ingredient.remainder"
            disabled
          >
        </div>
        <div class="form-group mb-3">
          <label>Введите новое значение остатка</label>
          <input
            type="text"
            class="form-control"
            name="ingredientRemainder"
            v-validate="'required'"
            v-model="ingredientRemainder"
            @input="validateInput"
            @blur="checkInput"
            data-vv-as="Новое значение"
          >
        </div>
      </div>
      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-primary ml-auto"
          @click="save"
        >Заполнить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'

  export default {
    props: ['machine', 'ingredient'],
    data () {
      return {
        ingredientRemainder: 0,
        errorMessage: "" // Сообщения об ошибках
      }
    },
    created() {
      // При создании компонента устанавливаем ingredientRemainder равным текущему количеству
      if (this.ingredient && this.ingredient.remainder !== undefined) {
        this.ingredientRemainder = this.ingredient.remainder;
      }
    },
    watch: {
      // Если ingredient изменяется (например, при повторном открытии модального окна), обновляем значение
      ingredient: {
        handler(newVal) {
          if (newVal && newVal.remainder !== undefined) {
            this.ingredientRemainder = newVal.remainder;
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
  validateInput(event) {
    let value = event.target.value;

    // Заменяем запятую на точку
    value = value.replace(/,/g, '.');

    if (this.ingredient.component.measure === "шт") {
      // Разрешаем только целые числа
      value = value.replace(/[^0-9]/g, '');
    } else {
      // Разрешаем только числа с максимум 3 знаками после точки
      value = value.replace(/[^0-9.]/g, ''); // Убираем всё, кроме цифр и точки

      // Убираем лишние точки, оставляя только одну
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
      }

      // Ограничиваем количество знаков после точки до 3
      if (parts.length === 2 && parts[1].length > 3) {
        parts[1] = parts[1].substring(0, 3);
        value = parts.join('.');
      }
    }

    // Проверяем, является ли текущее значение допустимым числом (но не удаляем точку!)
    if (value !== "" && value !== "." && value !== "-") {
      let numericValue = parseFloat(value);

      if (!isNaN(numericValue) && numericValue > this.ingredient.full) {
        value = this.ingredient.full.toString();
      }
    }

    this.ingredientRemainder = value;
  },

      checkInput() {
        if (!this.ingredientRemainder) {
          this.errorMessage = "Поле не может быть пустым";
        }
      },
      save () {
        if (window.confirm(`Заполняется ингредиент: ${this.ingredient.component.name} ? \nСтарое значение: ${this.ingredient.remainder} / ${this.ingredient.full}\nНовое значение: ${this.ingredientRemainder} / ${this.ingredient.full}`)) {
          let data = {
            component_id: this.ingredient.component_id,
            full: this.ingredientRemainder,
            product_number: this.ingredient.product_number
          }
          return api.post(`machines/${this.machine.id}/fillOnceIngredient`, data)
            .then(({data}) => {
              this.hide({critical_remainders: data.critical_remainders})
            })
        }
      },
      hide (data = null) {
        this.$emit('hide', data)
      },
    },
    computed: {
      options () {
        return this.matrix ? this.matrix.products.map((el) => el.product) : []
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/machines/modals/matrix-filling-ingredient.vue